import { useRoom } from '../../context/RoomContext';

export default function Countdown() {
  const { countdown } = useRoom();

  return <h1>{countdown}</h1>;
}
